// Components==============
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import Checkbox from '../Checkbox';
import './index.module.scss';
// =========================

const framerArrow = {
    open: {
        rotate: 180,
    },
    closed: {
        rotate: 0,
    },
};

const framerMenu = {
    open: {
        height: 'auto',

        transition: {
            delayChildren: 0.1,
            staggerChildren: 0.05,
        },
    },
    closed: {
        height: 0,

        transition: {
            duration: 0.25,
        },
    },
};

const framerMenuItem = {
    open: {
        opacity: 1,
        pointerEvents: 'all',
    },
    closed: {
        opacity: 0,
        transition: {
            duration: 0.1,
        },
        pointerEvents: 'none',
    },
};

export default function Dropdown({
    text,
    type,
    options,
    group,
    selected,
    setSelected,
    dashboard,
    absolute,
    colours,
}) {
    const [isDropped, setIsDropped] = useState(false);

    function handleClick(option) {
        if (type !== 'radio') {
            const exists = selected.find((current) => current === option);
            if (!exists) return setSelected((prev) => [...prev, option]);
            setSelected((prev) => prev.filter((current) => current !== option));
        }
    }

    const onOptionChange = (e) => {
        setSelected(e.target.value);
    };

    return (
        <motion.div
            initial="closed"
            animate={isDropped ? 'open' : 'closed'}
            styleName={`wrapper ${isDropped ? 'menuIsOpen' : ''} ${
                dashboard && 'dash'
            }`}
        >
            <div
                styleName="button"
                onClick={() => setIsDropped((prev) => !prev)}
            >
                <p>{text}</p>
                <motion.button variants={framerArrow} type="button">
                    <FontAwesomeIcon icon={faAngleDown} />
                </motion.button>
            </div>
            <AnimatePresence>
                {isDropped && (
                    <motion.div
                        styleName="menu"
                        style={{ position: absolute ? 'absolute' : 'initial' }}
                        variants={framerMenu}
                        exit="closed"
                        initial="closed"
                        animate={isDropped ? 'open' : 'closed'}
                    >
                        {type !== 'radio' ? (
                            <div styleName="padding">
                                {options.map((option, i) => {
                                    const isSelected = selected.find(
                                        (e) => e === option
                                    );

                                    return (
                                        <motion.div
                                            key={option}
                                            variants={framerMenuItem}
                                            styleName="menu-item"
                                            onClick={() => handleClick(option)}
                                        >
                                            <Checkbox
                                                isSelected={isSelected}
                                                background={
                                                    colours?.length
                                                        ? colours[i]
                                                        : undefined
                                                }
                                                opacity={
                                                    colours ? true : undefined
                                                }
                                            />
                                            <motion.p whileHover={{ x: 2 }}>
                                                {option}
                                            </motion.p>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div styleName="padding">
                                {options.map((option) => {
                                    const isSelected = selected === option;

                                    return (
                                        <motion.div
                                            key={option}
                                            variants={framerMenuItem}
                                            styleName="radio-menu-item"
                                            onClick={onOptionChange}
                                        >
                                            <input
                                                styleName="radio"
                                                type="radio"
                                                name={group}
                                                value={option}
                                                checked={isSelected}
                                            />
                                            <motion.p whileHover={{ x: 2 }}>
                                                {option}
                                            </motion.p>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}
